import { normalizeSpeckleServerUrl } from "./speckleServerUrl";

// The connector-facing server address, not VITE_SPECKLE_URL (which the app itself talks to). Some
// environments set it as a bare hostname, so it is normalized to gain a scheme before it is shown or copied.
export const SPECKLE_CONNECTOR_SERVER_URL = normalizeSpeckleServerUrl(import.meta.env.VITE_SPECKLE_CONNECTOR_URL);

// Revit, ArchiCAD and Rhino install the one Speckle Connector from here; Grasshopper has its own
// Real-Time LCA plugin, so per-tool specifics live in the docs.
export const SPECKLE_RELEASES_URL = "https://releases.speckle.systems/";
export const SPECKLE_DOCS_URL = "https://docs.realtimelca.com/user-guide/integrations/speckle";
